import React, { useContext } from 'react';

import CloseButton, {
  Variant as CloseVariant
} from '@swf/components/StarsModal/components/CloseButton';
import ModalHeader, {
  Variant as HeaderVariant
} from '@swf/components/StarsModal/components/Header/Header';

import CreateTournamentContext from '../../CreateTournament/CreateTournamentContext/CreateTournamentContext';

import styles from './Header.scss';

interface Props {
  title: React.ReactNode;
  subTitle?: React.ReactNode;
}

const Header: React.FC<Props> = ({ title = null, subTitle }) => {
  const {
    state: { isRecurrenceOpen }
  } = useContext(CreateTournamentContext);

  return (
    <ModalHeader className={styles.header} variant={HeaderVariant.Dark}>
      {title} {subTitle && <span>{subTitle}</span>}
      {!isRecurrenceOpen && <CloseButton variant={CloseVariant.Light} />}
    </ModalHeader>
  );
};

export default Header;
